var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Info-Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.02832 8.2655C9.44252 8.2655 9.77832 8.6013 9.77832 9.0155V14.0155C9.77832 14.4297 9.44252 14.7655 9.02832 14.7655C8.61412 14.7655 8.27832 14.4297 8.27832 14.0155V9.0155C8.27832 8.6013 8.61412 8.2655 9.02832 8.2655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.02832 6.5155C9.58062 6.5155 10.0283 6.06778 10.0283 5.5155C10.0283 4.96322 9.58062 4.5155 9.02832 4.5155C8.47602 4.5155 8.02832 4.96322 8.02832 5.5155C8.02832 6.06778 8.47602 6.5155 9.02832 6.5155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.27832 9.5155C0.27832 4.68301 4.19583 0.765503 9.02832 0.765503C13.8608 0.765503 17.7783 4.68301 17.7783 9.5155C17.7783 14.348 13.8608 18.2655 9.02832 18.2655C4.19583 18.2655 0.27832 14.348 0.27832 9.5155ZM9.02832 2.2655C5.02426 2.2655 1.77832 5.51144 1.77832 9.5155C1.77832 13.5196 5.02426 16.7655 9.02832 16.7655C13.0324 16.7655 16.2783 13.5196 16.2783 9.5155C16.2783 5.51144 13.0324 2.2655 9.02832 2.2655Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-Circle.204d610b9a47c3d80cb8567ed0ac602c.svg";
export { ForwardRef as ReactComponent };